var map = {
	"src/app/layouts/client-details/client-details.module": [
		"./src/app/layouts/client-details/client-details.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-new-restaurant~7acc484a",
		"src-app-layouts-client-details-client-details-module"
	],
	"src/app/pages/adminPanel/admin-dashboard/admin-dashboard.module": [
		"./src/app/pages/adminPanel/admin-dashboard/admin-dashboard.module.ts",
		"default~src-app-pages-adminPanel-admin-dashboard-admin-dashboard-module~src-app-pages-restaurantPane~58aba8ec",
		"src-app-pages-adminPanel-admin-dashboard-admin-dashboard-module"
	],
	"src/app/pages/adminPanel/admin-order-monitoring/admin-order-monitoring.module": [
		"./src/app/pages/adminPanel/admin-order-monitoring/admin-order-monitoring.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~36d213ab",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~63bae0b1",
		"common",
		"src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module"
	],
	"src/app/pages/adminPanel/admin-reservation-monitoring/admin-reservation-monitoring.module": [
		"./src/app/pages/adminPanel/admin-reservation-monitoring/admin-reservation-monitoring.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~36d213ab",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~63bae0b1",
		"common",
		"src-app-pages-adminPanel-admin-reservation-monitoring-admin-reservation-monitoring-module"
	],
	"src/app/pages/adminPanel/billing/restaurant-report-details/restaurant-report-details.module": [
		"./src/app/pages/adminPanel/billing/restaurant-report-details/restaurant-report-details.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"src-app-pages-adminPanel-billing-restaurant-report-details-restaurant-report-details-module"
	],
	"src/app/pages/adminPanel/billing/salles-report/salles-report.module": [
		"./src/app/pages/adminPanel/billing/salles-report/salles-report.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"src-app-pages-adminPanel-billing-salles-report-salles-report-module"
	],
	"src/app/pages/adminPanel/billing/transaction-summary/transaction-summary.module": [
		"./src/app/pages/adminPanel/billing/transaction-summary/transaction-summary.module.ts",
		"src-app-pages-adminPanel-billing-transaction-summary-transaction-summary-module"
	],
	"src/app/pages/adminPanel/billing/transaction/transaction.module": [
		"./src/app/pages/adminPanel/billing/transaction/transaction.module.ts",
		"src-app-pages-adminPanel-billing-transaction-transaction-module"
	],
	"src/app/pages/adminPanel/chain-management/chain-management.module": [
		"./src/app/pages/adminPanel/chain-management/chain-management.module.ts",
		"src-app-pages-adminPanel-chain-management-chain-management-module"
	],
	"src/app/pages/adminPanel/marketing/marketing.module": [
		"./src/app/pages/adminPanel/marketing/marketing.module.ts",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"src-app-pages-adminPanel-marketing-marketing-module"
	],
	"src/app/pages/adminPanel/new-restaurant/new-restaurant.module": [
		"./src/app/pages/adminPanel/new-restaurant/new-restaurant.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-new-restaurant~7acc484a",
		"src-app-pages-adminPanel-new-restaurant-new-restaurant-module"
	],
	"src/app/pages/adminPanel/platform-credentials-admin/platform-credentials-admin.module": [
		"./src/app/pages/adminPanel/platform-credentials-admin/platform-credentials-admin.module.ts",
		"src-app-pages-adminPanel-platform-credentials-admin-platform-credentials-admin-module"
	],
	"src/app/pages/adminPanel/restaurant-health/restaurant-health.module": [
		"./src/app/pages/adminPanel/restaurant-health/restaurant-health.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~36d213ab",
		"src-app-pages-adminPanel-restaurant-health-restaurant-health-module"
	],
	"src/app/pages/adminPanel/restaurant-synopsis/restaurant-synopsis.module": [
		"./src/app/pages/adminPanel/restaurant-synopsis/restaurant-synopsis.module.ts",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"src-app-pages-adminPanel-restaurant-synopsis-restaurant-synopsis-module"
	],
	"src/app/pages/adminPanel/restaurants/restaurants.module": [
		"./src/app/pages/adminPanel/restaurants/restaurants.module.ts",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~63bae0b1",
		"src-app-pages-adminPanel-restaurants-restaurants-module"
	],
	"src/app/pages/adminPanel/stripe-key-admin/stripe-key-admin.module": [
		"./src/app/pages/adminPanel/stripe-key-admin/stripe-key-admin.module.ts",
		"src-app-pages-adminPanel-stripe-key-admin-stripe-key-admin-module"
	],
	"src/app/pages/adminPanel/system-logs/system-logs.module": [
		"./src/app/pages/adminPanel/system-logs/system-logs.module.ts",
		"src-app-pages-adminPanel-system-logs-system-logs-module"
	],
	"src/app/pages/adminPanel/user/admin-user-blocklist/admin-user-blocklist.module": [
		"./src/app/pages/adminPanel/user/admin-user-blocklist/admin-user-blocklist.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~63bae0b1",
		"default~src-app-pages-adminPanel-user-admin-user-blocklist-admin-user-blocklist-module~src-app-pages~082cb0e4",
		"src-app-pages-adminPanel-user-admin-user-blocklist-admin-user-blocklist-module"
	],
	"src/app/pages/adminPanel/user/admin-user-monitoring/admin-user-monitoring.module": [
		"./src/app/pages/adminPanel/user/admin-user-monitoring/admin-user-monitoring.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~36d213ab",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~63bae0b1",
		"default~src-app-pages-adminPanel-user-admin-user-blocklist-admin-user-blocklist-module~src-app-pages~082cb0e4",
		"src-app-pages-adminPanel-user-admin-user-monitoring-admin-user-monitoring-module"
	],
	"src/app/pages/adminPanel/user/system-admin-users/system-admin-users.module": [
		"./src/app/pages/adminPanel/user/system-admin-users/system-admin-users.module.ts",
		"src-app-pages-adminPanel-user-system-admin-users-system-admin-users-module"
	],
	"src/app/pages/adminPanel/user/system-user-activities/system-user-activities.module": [
		"./src/app/pages/adminPanel/user/system-user-activities/system-user-activities.module.ts",
		"src-app-pages-adminPanel-user-system-user-activities-system-user-activities-module"
	],
	"src/app/pages/restaurantPanel/app-version-control/app-version-control.module": [
		"./src/app/pages/restaurantPanel/app-version-control/app-version-control.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"src-app-pages-restaurantPanel-app-version-control-app-version-control-module"
	],
	"src/app/pages/restaurantPanel/blog-management/blog-management.module": [
		"./src/app/pages/restaurantPanel/blog-management/blog-management.module.ts",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~e75d230f",
		"src-app-pages-restaurantPanel-blog-management-blog-management-module"
	],
	"src/app/pages/restaurantPanel/booking-deals/booking-deals.module": [
		"./src/app/pages/restaurantPanel/booking-deals/booking-deals.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"src-app-pages-restaurantPanel-booking-deals-booking-deals-module"
	],
	"src/app/pages/restaurantPanel/cms/all-pages/all-pages.module": [
		"./src/app/pages/restaurantPanel/cms/all-pages/all-pages.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~36d213ab",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~e75d230f",
		"src-app-pages-restaurantPanel-cms-all-pages-all-pages-module"
	],
	"src/app/pages/restaurantPanel/cms/custom-css/custom-css.module": [
		"./src/app/pages/restaurantPanel/cms/custom-css/custom-css.module.ts",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~e75d230f",
		"src-app-pages-restaurantPanel-cms-custom-css-custom-css-module"
	],
	"src/app/pages/restaurantPanel/cms/custom-pages/custom-pages.module": [
		"./src/app/pages/restaurantPanel/cms/custom-pages/custom-pages.module.ts",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~e75d230f",
		"src-app-pages-restaurantPanel-cms-custom-pages-custom-pages-module"
	],
	"src/app/pages/restaurantPanel/cms/seo/seo.module": [
		"./src/app/pages/restaurantPanel/cms/seo/seo.module.ts",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~e75d230f",
		"src-app-pages-restaurantPanel-cms-seo-seo-module"
	],
	"src/app/pages/restaurantPanel/coupon-management/coupon-management.module": [
		"./src/app/pages/restaurantPanel/coupon-management/coupon-management.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"common",
		"src-app-pages-restaurantPanel-coupon-management-coupon-management-module"
	],
	"src/app/pages/restaurantPanel/customers/customers.module": [
		"./src/app/pages/restaurantPanel/customers/customers.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"src-app-pages-restaurantPanel-customers-customers-module"
	],
	"src/app/pages/restaurantPanel/dashboard/dashboard.module": [
		"./src/app/pages/restaurantPanel/dashboard/dashboard.module.ts",
		"default~src-app-pages-adminPanel-admin-dashboard-admin-dashboard-module~src-app-pages-restaurantPane~58aba8ec",
		"src-app-pages-restaurantPanel-dashboard-dashboard-module"
	],
	"src/app/pages/restaurantPanel/delivery-area-management/delivery-area-management.module": [
		"./src/app/pages/restaurantPanel/delivery-area-management/delivery-area-management.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"common",
		"src-app-pages-restaurantPanel-delivery-area-management-delivery-area-management-module"
	],
	"src/app/pages/restaurantPanel/driver-management/driver-management.module": [
		"./src/app/pages/restaurantPanel/driver-management/driver-management.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"common",
		"src-app-pages-restaurantPanel-driver-management-driver-management-module"
	],
	"src/app/pages/restaurantPanel/event-management/event-management.module": [
		"./src/app/pages/restaurantPanel/event-management/event-management.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~e75d230f",
		"src-app-pages-restaurantPanel-event-management-event-management-module"
	],
	"src/app/pages/restaurantPanel/integration/booking-platform-integration/booking-platform-integration.module": [
		"./src/app/pages/restaurantPanel/integration/booking-platform-integration/booking-platform-integration.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"src-app-pages-restaurantPanel-integration-booking-platform-integration-booking-platform-integration-module"
	],
	"src/app/pages/restaurantPanel/integration/crm-integration/crm-integration.module": [
		"./src/app/pages/restaurantPanel/integration/crm-integration/crm-integration.module.ts",
		"src-app-pages-restaurantPanel-integration-crm-integration-crm-integration-module"
	],
	"src/app/pages/restaurantPanel/integration/delivery-platform-integration/delivery-platform-integration.module": [
		"./src/app/pages/restaurantPanel/integration/delivery-platform-integration/delivery-platform-integration.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"src-app-pages-restaurantPanel-integration-delivery-platform-integration-delivery-platform-integration-module"
	],
	"src/app/pages/restaurantPanel/integration/just-eat-daas-integration/just-eat-daas-integration.module": [
		"./src/app/pages/restaurantPanel/integration/just-eat-daas-integration/just-eat-daas-integration.module.ts",
		"src-app-pages-restaurantPanel-integration-just-eat-daas-integration-just-eat-daas-integration-module"
	],
	"src/app/pages/restaurantPanel/integration/payment-integration/payment-integration.module": [
		"./src/app/pages/restaurantPanel/integration/payment-integration/payment-integration.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"src-app-pages-restaurantPanel-integration-payment-integration-payment-integration-module"
	],
	"src/app/pages/restaurantPanel/integration/social-media-integration/social-media-integration.module": [
		"./src/app/pages/restaurantPanel/integration/social-media-integration/social-media-integration.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"src-app-pages-restaurantPanel-integration-social-media-integration-social-media-integration-module"
	],
	"src/app/pages/restaurantPanel/integration/web-integration/web-integration.module": [
		"./src/app/pages/restaurantPanel/integration/web-integration/web-integration.module.ts",
		"src-app-pages-restaurantPanel-integration-web-integration-web-integration-module"
	],
	"src/app/pages/restaurantPanel/loyalty-points/loyalty-points.module": [
		"./src/app/pages/restaurantPanel/loyalty-points/loyalty-points.module.ts",
		"src-app-pages-restaurantPanel-loyalty-points-loyalty-points-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/ala-carta/ala-carta.module": [
		"./src/app/pages/restaurantPanel/menu-setup/ala-carta/ala-carta.module.ts",
		"src-app-pages-restaurantPanel-menu-setup-ala-carta-ala-carta-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/category/category.module": [
		"./src/app/pages/restaurantPanel/menu-setup/category/category.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~36d213ab",
		"common",
		"src-app-pages-restaurantPanel-menu-setup-category-category-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/course/course.module": [
		"./src/app/pages/restaurantPanel/menu-setup/course/course.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"common",
		"src-app-pages-restaurantPanel-menu-setup-course-course-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/cuisine/cuisine.module": [
		"./src/app/pages/restaurantPanel/menu-setup/cuisine/cuisine.module.ts",
		"common",
		"src-app-pages-restaurantPanel-menu-setup-cuisine-cuisine-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/dish/dish.module": [
		"./src/app/pages/restaurantPanel/menu-setup/dish/dish.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"default~src-app-pages-restaurantPanel-menu-setup-dish-dish-module~src-app-pages-restaurantPanel-new-~106049f8",
		"common",
		"src-app-pages-restaurantPanel-menu-setup-dish-dish-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/duplicate-menu/duplicate-menu.module": [
		"./src/app/pages/restaurantPanel/menu-setup/duplicate-menu/duplicate-menu.module.ts",
		"common",
		"src-app-pages-restaurantPanel-menu-setup-duplicate-menu-duplicate-menu-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/grp-dish/grp-dish.module": [
		"./src/app/pages/restaurantPanel/menu-setup/grp-dish/grp-dish.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"common",
		"src-app-pages-restaurantPanel-menu-setup-grp-dish-grp-dish-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/pizza-dish/menu-entry/menu-entry.module": [
		"./src/app/pages/restaurantPanel/menu-setup/pizza-dish/menu-entry/menu-entry.module.ts",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"common",
		"src-app-pages-restaurantPanel-menu-setup-pizza-dish-menu-entry-menu-entry-module"
	],
	"src/app/pages/restaurantPanel/menu-setup/pizza-dish/menu-list/menu-list.module": [
		"./src/app/pages/restaurantPanel/menu-setup/pizza-dish/menu-list/menu-list.module.ts",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"common",
		"src-app-pages-restaurantPanel-menu-setup-pizza-dish-menu-list-menu-list-module"
	],
	"src/app/pages/restaurantPanel/new-schedule-management/new-schedule-management.module": [
		"./src/app/pages/restaurantPanel/new-schedule-management/new-schedule-management.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-pages-restaurantPanel-menu-setup-dish-dish-module~src-app-pages-restaurantPanel-new-~106049f8",
		"src-app-pages-restaurantPanel-new-schedule-management-new-schedule-management-module"
	],
	"src/app/pages/restaurantPanel/order-monitoring/order-monitoring.module": [
		"./src/app/pages/restaurantPanel/order-monitoring/order-monitoring.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"common",
		"src-app-pages-restaurantPanel-order-monitoring-order-monitoring-module"
	],
	"src/app/pages/restaurantPanel/printer-setting/printer-setting.module": [
		"./src/app/pages/restaurantPanel/printer-setting/printer-setting.module.ts",
		"common",
		"src-app-pages-restaurantPanel-printer-setting-printer-setting-module"
	],
	"src/app/pages/restaurantPanel/promotion-management/promotion-management.module": [
		"./src/app/pages/restaurantPanel/promotion-management/promotion-management.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"src-app-pages-restaurantPanel-promotion-management-promotion-management-module"
	],
	"src/app/pages/restaurantPanel/reservation-monitoring/reservation-monitoring.module": [
		"./src/app/pages/restaurantPanel/reservation-monitoring/reservation-monitoring.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~36d213ab",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~63bae0b1",
		"common",
		"src-app-pages-restaurantPanel-reservation-monitoring-reservation-monitoring-module"
	],
	"src/app/pages/restaurantPanel/restaurant-basic-information/restaurant-basic-information.module": [
		"./src/app/pages/restaurantPanel/restaurant-basic-information/restaurant-basic-information.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~e434f322",
		"src-app-pages-restaurantPanel-restaurant-basic-information-restaurant-basic-information-module"
	],
	"src/app/pages/restaurantPanel/restaurant-booking-setting/restaurant-booking-setting.module": [
		"./src/app/pages/restaurantPanel/restaurant-booking-setting/restaurant-booking-setting.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"src-app-pages-restaurantPanel-restaurant-booking-setting-restaurant-booking-setting-module"
	],
	"src/app/pages/restaurantPanel/restaurant-service-configuration/restaurant-service-configuration.module": [
		"./src/app/pages/restaurantPanel/restaurant-service-configuration/restaurant-service-configuration.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"src-app-pages-restaurantPanel-restaurant-service-configuration-restaurant-service-configuration-module"
	],
	"src/app/pages/restaurantPanel/review-monitoring/review-monitoring.module": [
		"./src/app/pages/restaurantPanel/review-monitoring/review-monitoring.module.ts",
		"src-app-pages-restaurantPanel-review-monitoring-review-monitoring-module"
	],
	"src/app/pages/restaurantPanel/schedule-management/schedule-management.module": [
		"./src/app/pages/restaurantPanel/schedule-management/schedule-management.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"src-app-pages-restaurantPanel-schedule-management-schedule-management-module"
	],
	"src/app/pages/restaurantPanel/system-users/system-users.module": [
		"./src/app/pages/restaurantPanel/system-users/system-users.module.ts",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"default~src-app-pages-adminPanel-admin-order-monitoring-admin-order-monitoring-module~src-app-pages-~54524a12",
		"src-app-pages-restaurantPanel-system-users-system-users-module"
	],
	"src/app/pages/restaurantPanel/voucher/voucher.module": [
		"./src/app/pages/restaurantPanel/voucher/voucher.module.ts",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~11289323",
		"default~src-app-layouts-client-details-client-details-module~src-app-pages-adminPanel-admin-order-mo~2c5351b9",
		"default~src-app-pages-restaurantPanel-app-version-control-app-version-control-module~src-app-pages-r~4422cabf",
		"default~src-app-pages-restaurantPanel-blog-management-blog-management-module~src-app-pages-restauran~5beea626",
		"src-app-pages-restaurantPanel-voucher-voucher-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;